import { useMenu } from 'catering/hooks/query';
import {
  getMenuItemsFromSections,
  getMenuUpsellItemsNotInCartWithAcceptableLeadTimes
} from 'catering/helpers/menu';
import { getDateTimeFromFulfillmentDateAndTime } from 'catering/helpers/dates';
import { formatCateringLocationInventory } from 'catering/helpers/formatCateringLocationInventory';

export function useGetUpsellItems(cart, locationInventory) {
  // has to query the full (unfiltered) menu for upsell items instead using menu context directly
  const { data: menu = {} } = useMenu();

  const menuItems = getMenuItemsFromSections(menu);

  const menuItemsWithInventory = cart?.items
    ? formatCateringLocationInventory(locationInventory, menuItems, cart)
    : menuItems;

  const fulfillmentDateTime = getDateTimeFromFulfillmentDateAndTime(
    cart?.fulfillment_date,
    cart?.fulfillment_time
  );

  const cartItems = cart?.items.map(item => item.product);

  const isUpsellEnabled = menu?.is_upsell_enabled;
  let upsellItems = [];

  if (isUpsellEnabled && !!cart) {
    upsellItems = getMenuUpsellItemsNotInCartWithAcceptableLeadTimes(
      cartItems,
      menuItemsWithInventory,
      menu.upsell_items,
      menu.upsell_type,
      fulfillmentDateTime
    );
  }

  return { isUpsellEnabled, upsellItems };
}
